import { ref, onMounted } from 'vue';
import { LAYOUT_SERVICES } from './constant';

/**
 * 页面初始化服务
 * @param type {string} layout 类型，取值：basic / act / static
 */
export const useInitService = (type: 'basic' | 'act' | 'static' = 'basic') => {
  // 是否初始化成功
  const isSuccess = ref(false);

  // 是否初始化完成
  const isReady = ref(false);

  onMounted(async () => {
    try {
      if (LAYOUT_SERVICES[type]?.length) {
        // 注意循环中执行异步操作时，要用没有回调的循环方式
        for (let i = 0; i < LAYOUT_SERVICES[type]?.length; i++) {
          typeof LAYOUT_SERVICES[type][i] === 'function' && (await LAYOUT_SERVICES[type][i]());
        }
      }
      isSuccess.value = true;
      console.log('加载页面初始化服务成功');
    } catch (err) {
      isSuccess.value = false;
      console.log('加载页面初始化服务错误：', err);
    } finally {
      // 初始化完成
      isReady.value = true;
    }
  });

  return {
    isSuccess,
    isReady,
  };
};
